import { useMemo } from 'react';
import { Dream } from '../types/dream';
import { CorrelationMatrix, EmotionTreemapData } from '../components/Statistics/types/emotionThemeTypes';
import { format } from 'date-fns';

export const useEmotionThemeCorrelation = (dreams: Dream[], period: number = 30): EmotionTreemapData[] => {
  console.log('Total dreams:', dreams.length);
  return useMemo(() => {
    if (!dreams || dreams.length === 0) {
      return [];
    }

    // Filtrer les rêves pour la période donnée
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - period);
    const filteredDreams = dreams.filter(dream => dream.createdAt >= cutoffDate);
    console.log('Dreams after date filter:', filteredDreams.length);

    // Créer la matrice de corrélation
    const correlationMatrix: CorrelationMatrix = {};

    // log debug
    const validDreams = filteredDreams.filter(dream => 
      dream.emotions && 
      dream.keywords && 
      dream.keywords.length > 0
    );
    console.log('Dreams with emotions and keywords:', validDreams.length);

    // Si aucun rêve valide, retourner un tableau vide
    if (validDreams.length === 0) {
      return [];
    }

    // Compter les associations
    validDreams.forEach(dream => {
      // Vérification de la présence des émotions
      if (!dream.emotions) return;
    
      const emotions = dream.emotions.split(',').map(e => e.trim());
      emotions.forEach(emotion => {
        if (!correlationMatrix[emotion]) {
          correlationMatrix[emotion] = {};
        }
    
        dream.keywords?.forEach(keyword => {
          if (!correlationMatrix[emotion][keyword]) {
            correlationMatrix[emotion][keyword] = {
              score: 0,
              dreams: []
            };
          }
    
          correlationMatrix[emotion][keyword].score++;
          correlationMatrix[emotion][keyword].dreams.push({
            id: dream.id,
            date: format(dream.createdAt, 'yyyy-MM-dd'),
            title: dream.text ? dream.text.substring(0, 50) + '...' : 'Sans titre'
          });
        });
      });
    });

    const treemapData = Object.entries(correlationMatrix)
  // Trier les émotions par score total
  .sort(([, a], [, b]) => {
    const totalScoreA = Object.values(a).reduce((sum, { score }) => sum + score, 0);
    const totalScoreB = Object.values(b).reduce((sum, { score }) => sum + score, 0);
    return totalScoreB - totalScoreA;
  })
  // Prendre uniquement les 5 premières
  .slice(0, 5)
  .map(([emotion, keywords]) => {
    const totalScore = Object.values(keywords).reduce((sum, { score }) => sum + score, 0);
    
    return {
      emotion,
      children: Object.entries(keywords).map(([keyword, data]) => ({
        theme: keyword,
        value: data.score / totalScore,
        intensity: data.score / Math.max(...Object.values(keywords).map(t => t.score)),
        details: {
          correlationScore: data.score / totalScore,
          totalOccurrences: data.score,
          dreams: data.dreams.slice(0, 5)
        }
      }))
    };
  });
    
    console.log('Final correlation data:', treemapData);
    return treemapData;
  }, [dreams, period]);
};
